import React from 'react';

const PageNotFound = () => {
    return (
        <div className="container m-5">
            <div className="text-danger text-center">
                <h1>page not found! <br /> error 404!</h1>
            </div>
        </div>
    );
};

export default PageNotFound;